export class ApiError extends Error {
  status: number;
  constructor(message: string, status: number) {
    super(message);
    this.status = status;
  }
}

export async function api<T>(method: string, path: string, body?: object): Promise<T> {
  const headers: Record<string, string> = { 'Content-Type': 'application/json' };
  const token = (window as any).__godbeyAuth?.getAccessToken?.();
  if (token) headers['Authorization'] = `Bearer ${token}`;
  const res = await fetch(`/api${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) {
    let msg = `Request failed (${res.status})`;
    try {
      const err = await res.json() as { error: string };
      msg = err.error ?? msg;
    } catch { /* not JSON */ }
    throw new ApiError(msg, res.status);
  }
  return res.json() as Promise<T>;
}

export function el<T extends HTMLElement>(id: string): T {
  return document.getElementById(id) as T;
}

export function showError(msg: string): void {
  const err = el('error-toast');
  err.textContent = msg;
  err.classList.remove('hidden');
  setTimeout(() => err.classList.add('hidden'), 3000);
}

let onScreen: ((id: string) => void) | null = null;

export function setOnScreen(fn: (id: string) => void): void {
  onScreen = fn;
}

export function showScreen(id: string): void {
  document.querySelectorAll<HTMLElement>('.screen').forEach(s => {
    s.classList.toggle('hidden', s.id !== id);
  });
  onScreen?.(id);
}
